<template>
    <CodiceFeanorView tool-module="argon2" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
